(() => {
	const orderrows = document.querySelectorAll('.dashboard-table__row--clickable');

	orderrows.forEach(row => {
		row.addEventListener('click', function(e) {
			let target = e.target;

			while (target && !target.classList.contains('dashboard-table__row--clickable')) {
				target = target.parentNode;
			}

			if(document.querySelector(`#${target.getAttribute('aria-controls')}`).hasAttribute('hidden')) {
				orderrows.forEach(openedRow => {
					document.querySelector(`#${openedRow.getAttribute('aria-controls')}`).setAttribute('hidden', true);
					openedRow.classList.remove('dashboard-table__row--opened');
				});
			}
			document.querySelector(`#${target.getAttribute('aria-controls')}`).toggleAttribute('hidden');
			target.classList.toggle('dashboard-table__row--opened');
		});
	});

})();